export const LOCALES = {
  en: 'en-GB',
  ru: 'ru-RU',
  uk: 'uk-UA',
  it: 'it-IT',
  de: 'de-DE',
  tr: 'tr-TR',
  es: 'es-ES'
} as const;
